import type { FC } from 'react'
import MobileHeaderButton from './MobileHeaderButton'
import { useBoolean } from 'react-use'
import { useDealFilters } from '../../DealFiltersProvider'
import CartButton from '../../../shopping-cart/buttons/CartButton'
import HeadlessModal from '@g4g/ui/src/adopted/HeadlessModal'
import MobileSortOptions from './MobileSortOptions'

const MobileSort: FC = () => {
  const [isOpen, toggleIsOpen] = useBoolean(false)
  const { sortBy } = useDealFilters()

  return (
    <>
      <MobileHeaderButton
        data-cy="shop-mobile-sort-toggle-modal-btn"
        btnType="sort"
        active={sortBy !== 'featured'}
        onClick={() => toggleIsOpen(true)}
      >
        Sort
      </MobileHeaderButton>
      <HeadlessModal
        mobileOnly
        title="Sort by"
        isOpen={isOpen}
        closeModal={() => toggleIsOpen(false)}
        modalFooter={
          <div className="flex w-full space-x-4">
            <CartButton
              data-cy="shop-filter-modal-done-btn"
              className="w-full h-12 text-lg"
              onClick={() => toggleIsOpen(false)}
            >
              Done
            </CartButton>
          </div>
        }
      >
        <div className="flex flex-col space-y-2">
          <MobileSortOptions sortBy={sortBy} />
        </div>
      </HeadlessModal>
    </>
  )
}

export default MobileSort
